export default __webpack_public_path__ + "static/TThover-59bfb368fc101948ba10eeebe040c40f.png";